export default __webpack_public_path__ + "static/media/modalSubmit.ee4c40db.png";